/* eslint-disable import/prefer-default-export */

/**
 * Given a collection of items, returns a unique colletion (no duplicates). This uniqueness
 * is determined by the passed uid which can be an actual id, but also any other field.
 * @example
 * ```js
 * const uniqueItems = getUniqueItems([{id: 1}, {id: 1}, {id: 2}, {id: 3}, {id: 3}], 'id');
 * ```
 * @param collection Collection of objects.
 * @param uid Identifier on which you would like to receive unique items.
 * @returns Collection of unique objects base on uid.
 */
export const getUniqueItems = <T>(collection: T[], uid: string): T[] => {
    const uniqueMap: { [uid: string]: boolean } = {};
    const uniqueCollection: T[] = [];

    collection.forEach((item) => {
        if (!uniqueMap[item[uid]]) uniqueCollection.push(item);
        uniqueMap[item[uid]] = true;
    });

    return uniqueCollection;
};
